<template>
    <v-text-field
      hide-details
      filled
      label=""
      dense
      flat
      solo
      :reverse=reverse
      :required="required"
      :value="value"
      :readonly="readonly"
      @input="handleInput"
      @change="handleChange"
      class="custom-text-field"
      background-color="white"
      :type="type"
      hide-spin-buttons
    ></v-text-field>
  </template>
  
  <script>
  export default {
    props: {
      value: [String, Number], 
      required: { 
        type: Boolean,
        default: false
      },
      readonly: { 
        type: Boolean,
        default: false
      },
      reverse: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'text'
      }
    },
    methods: {
      handleInput(newValue) {
        this.$emit('input', newValue);
      },
      handleChange(newValue) {
        this.$emit('change', newValue);
      }
    }
  };
  </script>
  
  <style scoped>
  /* Customize the styles for the text field */
  .custom-text-field {
    width: 100%; /* Make the text field occupy the full width of its container */
    height: 100%;
    
    margin: 0px; /* Remove any default margins */
    border: none; /* Remove borders */
    box-shadow: none; /* Remove box-shadow */
    /* Set background-color to transparent */
    padding: 0px;
    }

    .custom-text-field input {
        border: none; /* Remove input border */
        outline: none; /* Remove input outline */
    }
    .custom-text-field .v-text-field__slot {
        border-bottom: none; /* Remove the bottom border of the text field */
    }
  </style>

<style>
  .custom-text-field input::-webkit-outer-spin-button,
  .custom-text-field input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>